import { IconButton } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Close, Search, Send } from '@material-ui/icons';
import RoomIcon from '@material-ui/icons/Room';
import {
  checkAffiliateStudentOrganization,
  getInfosIndividual,
  getStudentGoal,
} from '@webapps/business';
import {
  Button,
  Modal as ModalComp,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';
import Modal, { default as ModalStep } from 'components/Modal';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import AffiliationSendBusiness from './AffiliationBusiness';
import AffiliationSendSchool from './AffiliationSchool';

const ProfilName = ({ info, closeModal }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const userid = info?.id;

  const { data: profilInfo = [] } = useQuery(getInfosIndividual, {
    key: ['profilInfo', userid],
    variables: { id: userid },
    enabled: typeof userid !== 'undefined',
  });

  return (
    <div className={classes.container}>
      <div>
        <IconButton
          style={{
            background: '#F3F7FF',
            border: '1px solid #C0D9FF',
            width: '30px',
            height: '30px',
            position: 'absolute',
            right: 10,
            top: 10,
          }}
          className={classes.mobileOnly}
          onClick={closeModal}
          size="small"
        >
          <Close style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
        </IconButton>
        <Grid className={classes.containerInfo} container>
          <div
            className={css({
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
              alignItems: 'start',
            })}
          >
            <div style={{ marginBottom: '20px' }}>
              <AvatarStudent applicant={info} height={89} width={89} />
            </div>
            <div>
              <div
                className={cx(global.mainTitle, classes.name)}
              >
                {profilInfo?.firstname} {profilInfo?.lastname}
              </div>
              <div className={cx(global.infoText, classes.address)}>
                {profilInfo?.address?.city && (
                  <>
                    <RoomIcon className={global.infoIcon} />
                    <div>
                      {profilInfo?.address?.city}{' '}
                      {profilInfo?.address?.cityCode}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </Grid>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    // borderBottom: 'solid 1px #E8E8E8',
  },
  containerInfo: {
    padding: spacing('20px', '30px'),
  },
  avatar: {
    height: 70,
    width: 70,
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: spacing(1),
  },
  name: {
    display: 'flex',
    alignItems: 'center',
  },
  LabelContainer: {
    paddingLeft: spacing(2),
  },
  gridBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: spacing(0.5),
  },
  favBtn: {
    textAlign: 'right',
  },
  ButtonContainer: {
    padding: spacing(2),
    paddingTop: spacing(0),
  },
  address: {
    display: 'flex',
    alignItems: 'top',
    marginTop: spacing(0.5),
  },
  mobileOnly: {
    '@media only screen and (min-width:1025px)': {
      display: 'none',
      '&:hover': { backgroundColor: 'transparent' },
    },
  },
});

ProfilName.propTypes = {
  info: PropTypes.object,
};

export default ProfilName;
